import  gql  from 'graphql-tag'

export const accessAttempts = gql`query AccessAttempts($name: String, $attemptTime_Gt: DateTime, $attemptTime_Lt: DateTime, $attemptType: String){
    accessAttempts(name: $name, attemptTime_Gt: $attemptTime_Gt, attemptTime_Lt: $attemptTime_Lt, attemptType: $attemptType){
        edges{
            node{
            id
            attemptTime
            attemptType
            ipAddress
            userAgent
            httpAccept
            attemptTypeDisplay
            user{
                username
                name
                surname
                group{
                    id
                    name
                }
                creditanalyst{
                    office{
                        id
                        name
                    }
                }
                officedirector{
                    office{
                        id
                        name
                    }
                }
            }
            
            }
        }
        }
    }`;